export function resizeHome(){
    var obj = {
		width: 0,
		height: 0,
		xScale: 0,
		yScale: 0
	};

	function setHomeSize() {
//		debugger
		console.log("home:::");
		var realWidth = $(".main-container").width();
		var realHeight = $(".main-container").height();
		var width = 0;
		var height = 0;
		var transition = 0;
		if(screen.width/screen.height == 3200/1890){
			width = 3200;
			height = 1890;
			transition = 50
		}else {
			width = 3200;
			height = 1890;
			transition = 50
		}
		// var width=
		obj.width = window.innerWidth;
		obj.height = window.innerHeight;
		obj.xScale = obj.width / width;
		obj.yScale = obj.height / height;
        obj.minScale = Math.min(obj.xScale,obj.yScale);
        window.minScale = obj.minScale;
//      obj.xScale =  obj.minScale;
//      obj.yScale =  obj.minScale;
		var jscss = [
			'.main-container {',
			'   transform: translate(' + (-transition * (1 - obj.xScale)) + '%,' + (-50 * (1 - obj.yScale)) + '%) scale(' + obj.minScale + ',' + obj.minScale + ');',
			'   -webkit-transform: translate(' + (-transition * (1 - obj.xScale)) + '%,' + (-50 * (1 - obj.yScale)) + '%) scale(' + obj.minScale + ',' + obj.minScale + ');',
			'}'
		].join('\n');

		var $style = $('#js-style');
		if ($style.length === 0) {
			$style = $('<style id="js-style" type="text/css"></style>');
			$style.appendTo('head');
		}
		$style.text(jscss);
	}
	setHomeSize();

	window.addEventListener('resize', setHomeSize, false);
	return obj;
}

